// used to debounce functions while correctly waiting for capybara-lockstep 
// use this instead of lodash _.debounce
export default (callback: Function,  wait: number) => {
  let timeoutId = null;
  let count = 0;

  return (...args) => {
    window.CapybaraLockstep?.startWork('Debounce')
    window.clearTimeout(timeoutId);
    count += 1;

    timeoutId = window.setTimeout(async () => {
      const result = await callback.apply(null, args);
      for (let i = 0; i < count; i++) {
        window.CapybaraLockstep?.stopWork('Debounce')
      }
      count = 0;
      return result;
    }, wait);
  };
}

